export default __webpack_public_path__ + "static/media/MarkPro-Light.5308f8eb.woff2";